const SET_GIFTS = 'SET_GIFTS';
const SET_REFACTORED_GIFTS = 'SET_REFACTORED_GIFTS';

export { SET_GIFTS, SET_REFACTORED_GIFTS };
